import { Controller } from "@hotwired/stimulus"
import { isLostOption, noteRequired } from "../lib/lost_reason_logic"

// A deal's "move to stage" form (deals/_move_form): the lost reason and note
// show, and are required, only while a lost stage is chosen; the note is
// required when the reason asks for it. Without JavaScript the fields are
// always there and the server decides (Crm::Deals::Mover).
export default class extends Controller {
  static targets = ["stage", "fields", "reason", "note"]

  connect() {
    this.toggle()
  }

  toggle() {
    const lost = isLostOption(this.stageTarget.selectedOptions[0])
    this.fieldsTarget.hidden = !lost
    this.reasonTarget.required = lost
    this.noteTarget.required = lost && noteRequired(this.reasonTarget.selectedOptions[0])
  }
}
